import { render } from "./ReturnProductList.vue?vue&type=template&id=171d255e"
import script from "./ReturnProductList.vue?vue&type=script&lang=js"
export * from "./ReturnProductList.vue?vue&type=script&lang=js"

import "./ReturnProductList.vue?vue&type=style&index=0&id=171d255e&lang=css"
script.render = render

export default script